import { useMemo, useState } from 'react'
import { Card } from '@/components/ui/card'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import RevenueMixChart from './revenue-mix-chart'
import RevenueMixTable from './revenue-mix-table'
import { pivotRevenueMixData } from '../utils'

const RevenueMixView = ({ roasData, isSimplified, summaryMode }) => {
  const [displayMode, setDisplayMode] = useState('percentage')

  const chartMixData = useMemo(() => {
    return pivotRevenueMixData(roasData?.dailyData || [], true, summaryMode)
  }, [roasData, summaryMode])

  const tableMixData = useMemo(() => {
    return pivotRevenueMixData(roasData?.dailyData || [], isSimplified, summaryMode)
  }, [roasData, isSimplified, summaryMode])

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex flex-col">
          <p className="text-sm text-destructive font-medium">
            性能限制：图表中仅支持精简模式
          </p>
        </div>
        
        <Tabs value={displayMode} onValueChange={setDisplayMode}>
          <TabsList className="grid w-[120px] grid-cols-2">
            <TabsTrigger value="value">$</TabsTrigger>
            <TabsTrigger value="percentage">%</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      <Card className="p-4">
        <RevenueMixChart data={chartMixData} displayMode={displayMode} isSimplified={true} />
      </Card>

      {tableMixData.length > 0 && <RevenueMixTable data={tableMixData} displayMode={displayMode} isSimplified={isSimplified} />}
    </div>
  )
}


export default RevenueMixView
